import React from "react";
import { motion } from "framer-motion";
import "./AboutCoreValues.css";

// Image imports
import cubeV from "../../Assets/about/V.png";
import cubeC from "../../Assets/about/C.png";
import cubeN from "../../Assets/about/N.png";
import cubeR from "../../Assets/about/R.png";

const AboutCoreValues = () => {
  return (
    <section className="core-values-section">
      <h2 className="core-values-heading">
        <span>VCNR Core Values</span>
      </h2>

      {/* Static Background Image */}
      <div className="core-values-3d-bg">
        <img src="/logo512.png" alt="Background Logo" className="core-values-image" />
      </div>

      {/* Top Row */}
      <div className="core-values-row top-row">
        <motion.div
          className="core-value-card"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <div className="core-value-image">
            <img src={cubeV} alt="Values-Led Innovation" />
          </div>
          <h3>Values-Led Innovation</h3>
          <p>
            We believe that innovation is meaningful only when it's built on
            values that serve humanity and society at large.
          </p>
        </motion.div>

        <motion.div
          className="core-value-card"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <div className="core-value-image">
            <img src={cubeR} alt="Responsibility" />
          </div>
          <h3>Responsibility</h3>
          <p>
            We own the outcomes of our actions with transparency, accountability,
            and a conscience that guides each of our steps.
          </p>
        </motion.div>
      </div>

      {/* Bottom Row */}
      <div className="core-values-row bottom-row">
        <motion.div
          className="core-value-card"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          viewport={{ once: true }}
        >
          <div className="core-value-image">
            <img src={cubeC} alt="Commitment" />
          </div>
          <h3>Commitment</h3>
          <p>
            Our promises are sacred. We are committed to excellence,
            responsibility, and delivering purpose in everything we undertake.
          </p>
        </motion.div>

        <motion.div
          className="core-value-card"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          viewport={{ once: true }}
        >
          <div className="core-value-image">
            <img src={cubeN} alt="Nation-First Thinking" />
          </div>
          <h3>Nation-First Thinking</h3>
          <p>
            Our work is inspired by national progress. From rural empowerment to
            industrial upliftment, we contribute to India's development story.
          </p>
        </motion.div>
      </div>

      {/* Footer Text */}
      <p>
        These values aren’t just statements. They are actions. They guide our
        hiring, our product <br />
        development, our stakeholder engagements, and the way we treat our
        communities.
      </p>
      <br />
      <button className="explore-btn">Download Our Brand Manifesto</button>
    </section>
  );
};

export default AboutCoreValues;
